export default `
  fragment ParagraphShareButtons on ParagraphShareButtons {
    id
    uuid
    entityBundle
  }
`